<template>
    <div class="info-button-holder" :class="{'disadvantage': type === 'disadvantage', 'active': active}">

        <div class="info-button" @click="active = !active">
            <svg v-if="type !== 'disadvantage'" width="57" height="84" fill="none" viewBox="0 0 57 84"> <g clip-path="url(#a)"> <mask id="b" width="57" height="84" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"> <path fill="#fff" d="M56.3 0H0v84h56.3V0Z"/> </mask> <g mask="url(#b)"> <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M28.3 53.1c8.119 0 14.7-6.581 14.7-14.7s-6.581-14.7-14.7-14.7-14.7 6.581-14.7 14.7 6.581 14.7 14.7 14.7Z"/> <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M19.5 50.7V82l8.6-8.6 8.6 8.6V50.7m8.7-26.4L27.6 42l-5-5"/> <path stroke="#fff" stroke-miterlimit="10" stroke-width="3" d="M18.9 73.4H10a8.024 8.024 0 0 1-8-8V10a8.024 8.024 0 0 1 8-8h36.3a8.024 8.024 0 0 1 8 8v55.4a8.024 8.024 0 0 1-8 8h-8.9"/> </g> </g> <defs> <clipPath id="a"> <path fill="#fff" d="M0 0h56.3v84H0z"/> </clipPath> </defs> </svg>
            <svg v-else width="84" height="79" viewBox="0 0 84 79" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M34.7835 6.15991L2.9835 64.2269C2.31627 65.4452 1.97771 66.816 2.00114 68.2048C2.02457 69.5936 2.40915 70.9524 3.11711 72.1475C3.82506 73.3425 4.83198 74.3326 6.03874 75.0204C7.24549 75.7082 8.61051 76.0699 9.99949 76.0699H73.6475C75.0369 76.0699 76.4023 75.708 77.6093 75.0199C78.8163 74.3318 79.8233 73.3411 80.5311 72.1455C81.2389 70.9499 81.6232 69.5907 81.6461 68.2015C81.6689 66.8123 81.3296 65.4411 80.6615 64.2229L48.8175 6.15588C48.1279 4.89739 47.1126 3.84752 45.8778 3.11633C44.643 2.38515 43.2343 1.99959 41.7993 2C40.3643 2.00041 38.9558 2.38676 37.7214 3.11865C36.4871 3.85054 35.4723 4.90102 34.7835 6.15991Z" stroke="#001135" stroke-width="4" stroke-miterlimit="10"/> <path d="M41.8206 60.9971C42.649 60.9971 43.3206 60.3255 43.3206 59.4971C43.3206 58.6686 42.649 57.9971 41.8206 57.9971C40.9921 57.9971 40.3206 58.6686 40.3206 59.4971C40.3206 60.3255 40.9921 60.9971 41.8206 60.9971Z" stroke="#001135" stroke-width="4"/> <path d="M41.8225 25.0327V47.3387" stroke="#001135" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/> </svg>
        </div>

        <transition name="fade">
            <div class="content" v-if="active">
                <slot />
            </div>
        </transition>

    </div>
</template>

<script>

    export default {
        props: ['type'],
        data() {
            return {
                active: false
            }
        }
    }

</script>

<style lang="scss" scoped>

    @import '~@/assets/scss/_variables.scss';

    .info-button-holder {
        display: inline-block;
        position: relative;
        margin: 10px 0 0;
        user-select: none;

        + .info-button-holder { margin-top: -40px; }

        .info-button {
            background-color: white;
            border-radius: 50%;
            width: 100px;
            height: 100px;
            position: relative;
            z-index: 1;
            margin: 16px 0 0 16px;
            transition: background-color .3s;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            svg {
                width: 40px;

                path {
                    stroke: #005AFF;
                    transition: stroke .3s;
                }
            }

            &:after {
                border-radius: 50%;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                box-shadow: 0 0 0 0 rgba(white, 1);
                transform: scale(1);
                animation: pulseBlue 2s infinite;
                opacity: 1;
                transition: opacity .5s;
                pointer-events: none;
                content: '';

                @keyframes pulseBlue {
                    0% {
                        transform: scale(0.95);
                        box-shadow: 0 0 0 0 rgba(white, 0.7);
                    }

                    70% {
                        transform: scale(1);
                        box-shadow: 0 0 0 30px rgba(white, 0);
                    }

                    100% {
                        transform: scale(0.95);
                        box-shadow: 0 0 0 0 rgba(white, 0);
                    }
                }
            }
        }

        .content {
            background: white;
            position: absolute;
            top: 18px;
            left: 66px;
            width: 460px;
            min-height: 98px;
            padding: 20px 20px 20px 74px;
        }

        &.disadvantage .info-button {
            background: #01516E;

            svg { position: relative; top: -2px; path { stroke: white; } }
        }

        &.active .info-button {
            background-color: #001135;

            svg path { stroke: white; }
        }

        &.active .info-button:after { opacity: 0; }


        @include custom-breakpoint(1100) {

            .info-button {
                margin-top: 0;
                background-size: 50%;
                width: 60px;
                height: 60px;
            }

            .content {
                top: 0;
                left: 46px;
                width: 440px;
                padding: 12px 12px 12px 60px;
            }
        }
    }

</style>